export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_PROFILE = 'USER_PROFILE';
export const SHOW_CALENDAR_MODAL = 'SHOW_CALENDAR_MODAL';
